import { render, staticRenderFns } from "./MyQualityIssues.vue?vue&type=template&id=4b18d88f&scoped=true"
import script from "./MyQualityIssues.vue?vue&type=script&lang=js"
export * from "./MyQualityIssues.vue?vue&type=script&lang=js"
import style0 from "./MyQualityIssues.vue?vue&type=style&index=0&id=4b18d88f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b18d88f",
  null
  
)

export default component.exports